<template>
  <div class="main-queue">

    <main>
      <header>
        <div style="display: flex; align-items: center;">
          <a-page-header  @back="affairReturn" v-if="affairSoHid" class="job-page">
            <template slot="extra">
              <span @click="affairReturn">返回</span>
            </template>
          </a-page-header>
          <h3 :style="affairSoHid == true ? 'border-left: 2px solid #dcdfe6;' : ''">
            {{ affairSoHid == true ?  "查看事务项"+'_'+ oneData.name : "队列管理" }}
          </h3>
        </div>

        <div  style="display: flex;"  v-if="affairSoHid">
          <a-popconfirm
              title="导出的表格数据量最大支持5000，确定要导出吗？"
              ok-text="确定"
              cancel-text="取消"
              :disabled="queueExportDis"
              @confirm="exportQuery('作业管理')"
              v-if="$IA('system:queueitem:export')"
          >
            <a-button  icon="to-top"  style="margin:0 15px"   :disabled="queueExportDis"  type="primary" >事务导出</a-button>
          </a-popconfirm>

          <a-button  icon="vertical-align-bottom"    v-if="$IA('system:queueitem:importQueueItem')"   type="primary" @click="importQueue" >事务导入</a-button>

        </div>
        <div class="btn-group" v-if="!affairSoHid">

          <a-button v-if="$IA('system:queue:save')" type="primary" style="margin-right:0px" icon="plus" @click="handleOpen('添加')"
          >添加</a-button
          >
        </div>
        <!-- <span
          >/ {{ affairSoHid == true ? "affair queue" : "queue" }} management</span
        > -->
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText" >
            <a-input-search
                :placeholder="affairSoHid == true ? '参考' : '名称'"
                style="width: 200px; "
                allow-clear
                v-model="pagination.searchText"
                :loading="btnLoad"
                @input="searchTextChange"
                @search="searchTextChange"
            />
          </a-form-model-item>
          <a-form-model-item prop="status" v-if="affairSoHid == true">
            <a-select v-model="pagination.status" placeholder="状态" style="width: 180px;" allowClear
                      :loading="btnLoad" @change="searchJournalChange">
              <a-select-option  v-for="(item,index) in statsList" :value="index">{{item}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="exceptionType" v-if="affairSoHid == true">
            <a-select placeholder="异常" v-model="pagination.exceptionType" style="width: 180px;" :loading="btnLoad"
                      allow-clear @change="searchJournalChange">
              <a-select-option value="1">系统异常</a-select-option>
              <a-select-option value="2">业务异常</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="time" v-if="affairSoHid == true">
            <a-range-picker :value="pagination.time" v-model="pagination.time"
                            :placeholder="['创建时间: 开始', '创建时间: 结束']"  valueFormat="YYYY-MM-DD" style="width: 300px;" @change="searchJournalChange" />
          </a-form-model-item>
          <a-form-model-item  prop="orgId"  v-if="!affairSoHid ">
            <a-tree-select
                v-model='pagination.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                style="width: 180px; "
                @change="searchChange"
                show-search
                :filterTreeNode="filter_tree_node"
                placeholder="选择部门"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item >
            <a-button @click="resetSearch"  style="width: 74px" :style="affairSoHid ? '':'margin-right: 15px'">重 置</a-button>
          </a-form-model-item>
        </a-form-model>



      </div>
      <!-- 数据表格 -->
      <a-table
          v-if="!affairSoHid"
          :columns="tableColumns"
          :data-source="tableData"
          :pagination="queryCondition"
          :loading="tableLoad"
          @change="handleTableChange"
          bordered
          :scroll="{ y: 560 }"
      >
        <span slot="action" slot-scope="record"  class="table-action-box">
              <a-tooltip  content="" v-if="$IA('system:queueitem:index')" title="查看事务项" placement="top" effect="light">
              <i class="table-view" @click="examineAffair('查看事务项', record)" ></i>
            </a-tooltip>
             <a-tooltip  content="" v-if="$IA('system:queue:update')" title="修改" placement="top" effect="light">
              <i class="table-edit" @click="handleOpen('修改', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:queue:delete')" title="删除" placement="top" effect="light">
              <i class="table-delected" @click="handleOpen('删除', record)" ></i>
            </a-tooltip>

        </span>
      </a-table>
      <!-- 事务管理 -->
      <a-table
          v-if="affairSoHid"
          :columns="affairColumns"
          :data-source="columnsData"
          :pagination="affairCondition"
          :loading="affairLoad"
          @change="journalTableChange"
          bordered
          :scroll="{ y: 560 }"
      >
        <template slot="status" slot-scope="text">
          {{ statsList[text] }}
        </template>
        <template slot="priority" slot-scope="text">
          {{ priorityName[text] }}
        </template>
        <template slot="exceptionType" slot-scope="text">
          {{ exceptionList[text] }}
        </template>
        <span slot="action" slot-scope="record" class="table-action-box">
<!--          <a-dropdown placement="bottomRight" :trigger="['click']">-->
<!--            <i class="ant-dropdown-link table-action" />-->
<!--            <a-menu slot="overlay">-->
<!--              &lt;!&ndash; <a-menu-item @click="affairOpen('查看', record)"-->
<!--                ><a-icon type="eye" /><span>查看</span></a-menu-item-->
<!--              > &ndash;&gt;-->
<!--              <a-menu-item :disabled="[1,6,3].includes(record.status)" @click="affairOpen('编辑', record) "-->
<!--              ><a-icon type="edit" /><span>编辑</span></a-menu-item-->
<!--              >-->
<!--              <a-menu-item :disabled="record.status == 6" @click="affairOpen('克隆', record)"-->
<!--              ><a-icon type="copy" /><span>克隆</span></a-menu-item-->
<!--              >-->
<!--              <a-menu-item :disabled="[1,6].includes(record.status)"  @click="affairOpen('删除', record)"-->
<!--              ><a-icon type="delete" /><span>删除</span></a-menu-item-->
<!--              >-->
<!--              </a-menu>-->
<!--          </a-dropdown>-->


<!--            <a-tooltip  content="" v-if="[1,6,3].includes(record.status)" title="编辑" placement="top" effect="light">-->
<!--              <i class="table-edit" @click="affairOpen('编辑', record)" ></i>-->
<!--            </a-tooltip>-->
<!--            <a-tooltip  content="" v-if="record.status == 6" title="克隆" placement="top" effect="light">-->
<!--              <i class="table-copy" @click="affairOpen('克隆', record)" ></i>-->
<!--            </a-tooltip>-->
<!--            <a-tooltip  content="" v-if="[1,6].includes(record.status)" title="删除" placement="top" effect="light">-->
<!--              <i class="table-delected" @click="affairOpen('删除', record)" ></i>-->
<!--            </a-tooltip>-->


            <a-tooltip  content="" v-if="$IA('system:queueitem:update')" title="编辑" placement="top" effect="light">
              <i class="table-edit" @click="affairOpen('编辑', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:queueitem:clone')" title="克隆" placement="top" effect="light">
              <i class="table-copy" @click="affairOpen('克隆', record)" ></i>
            </a-tooltip>
            <a-tooltip v-if="$IA('system:queueitem:getqueuedetail')" content="" title="详细信息" placement="top" effect="light">
              <i class="table-view" @click="detailedAffairOpen('详细信息', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:queueitem:delete')" title="删除" placement="top" effect="light">
              <i class="table-delected" @click="affairOpen('删除', record)" ></i>
            </a-tooltip>



        </span>
      </a-table>
    </main>

    <!-- 操作模态框 -->
    <a-modal
        centered
        :title="modalTitle + '队列'"
        :visible="modalVisible"
        :confirm-loading="submitLoad"
        @ok="handleOk"
        @cancel="resetForm"
        :footer="modalTitle == '查看' ? null : undefined"
        :maskClosable="false"
        :width="modalTitle == '删除'? '420px' : '520px'"
    >
      <a-form-model
          v-if="['添加', '修改'].includes(modalTitle)"
          layout="vertical"
          :model="addForm"
          ref="addForm"
          :rules="addFormRules"
      >
        <a-form-model-item prop="id" v-show="false">
          <a-input v-model="addForm.id" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="队列名称" prop="name">
          <a-input v-model="addForm.name" placeholder="请输入"  :disabled="modalTitle == '修改'"  />
        </a-form-model-item>
        <a-form-model-item label="部门" prop="orgId">
          <a-tree-select
              v-model='addForm.orgId'
              allowClear
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="选择部门"
              tree-default-expand-all
              show-search
              :filterTreeNode="filter_tree_node"
              :replaceFields="{ title: 'name', key: 'id',value:'id' }"
          >
          </a-tree-select>
        </a-form-model-item>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="唯一参考" prop="enforceUniqueReference">
              <a-radio-group v-model="addForm.enforceUniqueReference" :disabled=" modalTitle == '修改' ">
                <a-radio :value="true"> 是 </a-radio>
                <a-radio :value="false"> 否 </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="自动重试" prop="automaticallyRetry">
              <a-radio-group v-model="addForm.automaticallyRetry" :disabled=" modalTitle == '修改' ">
                <a-radio :value="true"> 是 </a-radio>
                <a-radio :value="false"> 否 </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="最大重试次数" prop="maxNumberOfRetries"
                           :rules="[
            {
              required: addForm.automaticallyRetry,
              message: '最大重试次数不能为空',
              trigger: 'blur'
            },
          ]" class="detection-time"
        >
          <a-input-number v-model="addForm.maxNumberOfRetries" :min="1" :max="50" placeholder="请输入" :disabled=" modalTitle == '修改' " style='width: 480px;' />
        </a-form-model-item>
        <a-form-model-item label="描述" prop="description">
          <a-textarea
              v-model="addForm.description"
              placeholder="请输入"
          /> </a-form-model-item>
      </a-form-model>


      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该队列,是否继续?</p>
      </div>
    </a-modal>

    <!-- 事务操作模态框 -->
    <a-modal
        centered
        :title="affairTitle + '事务'"
        :visible="affairVisible"
        :confirm-loading="btnLoad"
        @ok="affairHandleOk"
        @cancel="affairVisible = false"
        :footer="affairTitle == '查看' ? null : undefined"
        :width="affairTitle == '查看' ? '880px' : '520px'"
        :maskClosable="false"
    >
      <a-table
          bordered
          v-if="affairTitle == '查看'"
          :columns="detailColumns"
          :data-source="queueItemData"
          :pagination="queueItemTion"
          :loading="queueItemLoad"
          @change="queueItemTableChange"
          style="margin-top:20px;"
      >
      </a-table>

      <a-form-model
          v-if="affairTitle == '编辑' || affairTitle == '克隆' "
          layout="vertical"
          :model="affairForm"
          ref="affairForm"
          :rules="affairFormRules"
      >
        <a-form-model-item prop="id" v-show="false">
          <a-input v-model="affairForm.id" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="参考" prop="queueItemReference">
          <a-input v-model="affairForm.queueItemReference" placeholder="请输入"   />
        </a-form-model-item>

        <a-form-model-item label="优先级" prop="priority">
          <a-select v-model="affairForm.priority" placeholder="请选择">
            <a-select-option v-for="(v, index) in priorityName" :key="index" :value="Number(index)">
              <img :src="priorityIcon[index]" style="margin-top: -5px" />
              {{ v }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="内容" prop="queueItemContentsJSON">
          <a-tooltip placement="topLeft"   style="position:absolute;  top: -60px; left: 35px " overlayClassName="form_tooltip">
            <template slot="title">
              <span> 格式为：[{"name": "aa", "value": "bb"},....]</span>
            </template>
            <a-icon type="info-circle" />
          </a-tooltip>
          <a-textarea
              v-model="affairForm.queueItemContentsJSON"
              placeholder="请输入"
          /> </a-form-model-item>
<!--        <a-form-model-item label="异常" prop="exceptionType">-->
<!--          <a-select  v-model="affairForm.exceptionType"-->
<!--                     allow-clear disabled>-->
<!--            <a-select-option :value="0">成功</a-select-option>-->
<!--            <a-select-option :value="1">系统异常</a-select-option>-->
<!--            <a-select-option :value="2">业务异常</a-select-option>-->
<!--          </a-select>-->


<!--          <div class="fail_Info" v-if="affairForm.exceptionType !=0">-->
<!--            <p>-->
<!--              <i></i>-->
<!--              <label>失败原因：</label>-->
<!--              <span>{{this.affairForm.processingExceptionReason ? this.affairForm.processingExceptionReason : '&#45;&#45;'}}</span>-->
<!--            </p>-->
<!--            <p>-->
<!--              <i></i>-->
<!--              <label>失败信息：</label>-->
<!--              <span>{{this.affairForm.processingExceptionDetails ? this.affairForm.processingExceptionDetails : '&#45;&#45;'}}</span>-->
<!--            </p>-->


<!--          </div>-->
<!--        </a-form-model-item>-->

        <!-- <a-form-model-item label="状态" prop="status" >
          <a-radio-group v-model="affairForm.status" :disabled="this.affairTitle == '克隆'">
            <a-radio :value="1"> 保存当前事务进度 </a-radio>
            <a-radio :value="0"> 重置事务进度 </a-radio>
          </a-radio-group>
        </a-form-model-item> -->
      </a-form-model>


      <div class="deleteBox" v-if="affairTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该事务,是否继续?</p>
      </div>
    </a-modal>


    <!-- 导入-->
    <a-modal
        centered
        title="导入"
        :confirm-loading="uploading"
        :visible="importModalVisible"
        @ok="handleUpload"
        cancel-text="关闭"
        ok-text="提交"
        @cancel="resetFile"
        :maskClosable="false"
    >
      <div class="import_div">
        <div>
          <label> <span>※</span> 文件选择</label>
          <p style="display: flex;align-items: center;">


            <a-upload :file-list="fileList"  accept='.xls' :before-upload="beforeUpload">
              <a-button   > <a-icon type="upload" />
                {{ this.fileList.length>0? this.fileList[0].name : '选择xls文件' }} </a-button>
            </a-upload>

            <a-icon type="close-circle" style="margin-left: 10px" @click="handleRemove" v-if="this.fileList.length>0" />


          </p>
        </div>
        <div>
          <label> <span>※</span> 模板下载</label> <p  style="margin-top: 5px" > <a :href="axios.defaults.baseURL + '/queueItem/download?token=' + $store.state.user.token"><a-icon type="file" /> 数据模板.xls</a></p>
        </div>
      </div>
    </a-modal>

    <!-- 事务操作模态框 -->
    <a-modal
        centered
        title="详细信息"
        :visible="detailedAffairVisible"
        :confirm-loading="btnLoad"
        @cancel="detailedAffairVisible = false"
        :footer="null"
        width="660px"
        :maskClosable="false"
    >
      <div class="detailed_info_box">
         <div class="remarks" style="display: flex;">
           <h4>事务编号：
           </h4>
           <span> {{  this.detailedAffairForm.queueId}}</span>
         </div>

         <div class="remarks">
           <h4>数据内容</h4>
           <a-input disabled v-model="this.detailedAffairForm.queueItemContentsJSON" placeholder="Basic usage" />
         </div>

          <h4 style="font-weight: 600">
            异常
          </h4>
          <div class="abnormal">
            <i></i>
            <label>
              异常原因：
            </label>
            <span>
               {{ this.detailedAffairForm.processingExceptionReason  ? this.detailedAffairForm.processingExceptionReason : '--'}}
            </span>
          </div>
          <div class="abnormal">
            <i></i>
            <label>
              详细信息：
            </label>
            <span>
              {{ this.detailedAffairForm.processingExceptionDetails ? this.detailedAffairForm.processingExceptionDetails : '--' }}
            </span>
          </div>
      </div>
     <div class="table-box">
       <a-table
           bordered
           :columns="detailedAffairColumns"
           :data-source="detailedAffairData"
           :loading="detailedAffairLoad"
           :pagination="false"
       >
         <template slot="status" slot-scope="text">
           {{ statsList[text] }}
         </template>
         <template slot="exceptionType" slot-scope="text">
           {{ exceptionList[text] }}
         </template>
       </a-table>
     </div>



    </a-modal>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      submitLoad:false,
      // 控制事务显隐
      affairSoHid: false,
      pagination: {
        searchText: "",
        pageSize: 10,
        pageNo: 1,
        current: 1,
        total: 0,
        time:'',
        status:undefined,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      affairTion:{
        searchText: "",
        pageSize: 10,
        status: undefined,
        pageNo: 1,
        current: 1,
        total: 0,
        exceptionType:undefined,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `,
        queueId: "",
      },
      queueItemTion:{
        searchText: "",
        pageSize: 10,
        pageNo: 1,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `,
        queueitemId : "",
      },
      affairLoad: false,
      queueItemLoad:false,
      formLayout:"inline",
      queryCondition: {},
      affairCondition: {},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
          ellipsis: true,
        },
        {
          title: "进行数",
          dataIndex: "executedNum",
          key: "executedNum",
        },
        {
          title: "剩余数",
          key: "unExecuteNum",
          dataIndex: "unExecuteNum",
        },
        {
          title: "成功数",
          key: "successNum",
          dataIndex: "successNum",
        },
        {
          title: "平均时间（分钟）",
          key: "avgExecuteTime",
          dataIndex: "avgExecuteTime",
        },
        {
          title: "系统错误",
          key: "appExceptionNum",
          dataIndex: "appExceptionNum",
        },
        {
          title: "业务错误",
          key: "businessExceptionNum",
          dataIndex: "businessExceptionNum",
        },
        {
          title: "部门",
          key: "orgName",
          dataIndex: "orgName",
          ellipsis: true,
        },
        {
          title: "描述",
          key: "description",
          dataIndex: "description",
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
          width: 120,
        },
      ],
      oneData:{},
      tableData: [],
      // 事务管理
      affairColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
          ellipsis: true,
        },
        {
          title: "参考",
          dataIndex: "queueItemReference",
          key: "queueItemReference",
          ellipsis: true,
        },
        {
          title: "优先级",
          key: "priority",
          dataIndex: "priority",
          scopedSlots: { customRender: "priority" },
          ellipsis: true,
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          ellipsis: true
        },
        {
          title: "开始时间",
          key: "beginDate",
          dataIndex: "beginDate",
          ellipsis: true,
        },
        {
          title: "结束时间",
          key: "endDate",
          dataIndex: "endDate",
          ellipsis: true,
        },
        {
          title: "机器人",
          key: "robotName",
          dataIndex: "robotName",
          ellipsis: true,
        },
        {
          title: "异常",
          key: "exceptionType",
          dataIndex: "exceptionType",
          scopedSlots: { customRender: "exceptionType" },
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
          width: 140,
        },
      ],
      columnsData: [],
      queueItemData:[],
      //事务详细
      detailColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
          ellipsis: true
        },
        {
          title: "值",
          dataIndex: "value",
          key: "value",
          ellipsis: true
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          ellipsis: true
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          key: "updateTime",
          ellipsis: true
        },
      ],
      detailData: [],
      // 模态框显隐
      modalVisible: false,
      // 事务模态框显隐
      affairVisible: false,
      // 模态框标题
      modalTitle: "",
      // 事务模态框
      affairTitle: "",
      // 添加/删除api
      saveApi:"",
      // 单条数据
      singleDta:"",
      //部门下拉框
      treeData:[],
      // 添加表单
      addForm: {
        id: "",
        name: "",
        orgId:undefined,
        description: "",
        enforceUniqueReference: true,
        automaticallyRetry: true,
        maxNumberOfRetries: 1,

      },
      addFormRules: {
        name: [
          { required: true, message: "队列名称不能为空" },
          { max: 20, message: '最长不能超过20字符' }
        ],
        orgId: [{ required: true, message: "部门不能为空" }],
        enforceUniqueReference: [
          { required: true, message: "唯一参考不能为空" },
        ],
        description:[
          { max: 250, message: '最长不能超过250字符' }
        ],
        automaticallyRetry: [{ required: true, message: "自动重试不能为空" }],
        maxNumberOfRetries: [
          { required: true, message: "最大重试次数不能为空" },
        ],
      },
      // 状态
      statsList:{
        0:"新建",
        1:"正在执行",
        2:'失败',
        3:'成功',
        4:'已放弃',
        5:'重试',
        6:'已删除',
      },
      // 异常
      exceptionList:{
        1:"系统异常",
        2:'业务异常'
      },
      // 分页参数
      pagCurrent:{},
      // 克隆表单
      cloneForm:{},
      // 事务
      affairForm:{
        id:'',
        queueItemReference:"",
        queueItemContentsJSON:'',
        priority:3,
        // status:0,
        description:"",
        exceptionType:undefined,
        processingExceptionReason:'',
        processingExceptionDetails:''
      },
      // 优先级字典
      priorityName: {
        0: "低",
        1: "中",
        2: "高",
      },
      priorityIcon: {
        0: require("../assets/images/low.png"),
        1: require("../assets/images/normal.png"),
        2: require("../assets/images/height.png"),
        3: require("../assets/images/inherited.png"),
      },
      affairFormRules:{
        // queueItemReference : [{ required: true, message: "参考不能为空" }],
        priority : [{ required: true, message: "优先级不能为空" }],
        status : [{ required: true, message: "状态不能为空" }],
      },



      // 导入 || 导出
      importModalVisible:false,
      fileList: [],
      uploading: false,
      queueExportDis:false,


      // 详细信息
      detailedAffairVisible:false,
      detailedAffairLoad:false,
      detailedAffairData:[],
      detailedAffairForm:{},
      detailedAffairColumns:[
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
          ellipsis: true,
        },
        {
          title: "重试次数",
          dataIndex: "errorNumberOfRetries",
          key: "errorNumberOfRetries",
          scopedSlots: { customRender: "errorNumberOfRetries" },
          ellipsis: true,
        },
        {
          title: "开始时间",
          key: "beginDate",
          dataIndex: "beginDate",
          ellipsis: true,
        },
        {
          title: "结束时间",
          key: "endDate",
          dataIndex: "endDate",
          ellipsis: true,
        },
        {
          title: "机器人",
          key: "robotName",
          dataIndex: "robotName",
          ellipsis: true,
        },
        {
          title: "异常",
          key: "exceptionType",
          dataIndex: "exceptionType",
          scopedSlots: { customRender: "exceptionType" },
          ellipsis: true,
        },
      ]
    };
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 重置表单通用方法
    resetForm() {
      if ( this.modalTitle =='添加' || this.modalTitle =='修改' ) {
        this.$refs.addForm.resetFields()
      }
      this.modalVisible = false
    },
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.affairTion.searchText = ''

      if (this.affairSoHid == false) {
        this.searchChange()
        this.queueExportDis = false
      }else{
        this.searchJournalChange()
      }
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title;
      this.modalVisible = true;
      this.singleDta = data
      switch (title) {
        case "添加":
          this.saveApi= '/queue/save'
          // this.addForm.orgId = this.$store.state.user.userInfo.orgId
          break;
        case "修改":
          this.saveApi = '/queue/update'
          this.$nextTick(()=>{
            this.addForm = this.$lodash.pick(
                this.singleDta,
                this.$lodash.keys(this.addForm)
            );
          })
          break;
        case "删除":
          break;
      }
    },
    // 事务查看详细信息 start
    detailedAffairOpen(title,data){
     this.detailedAffairVisible = true
     this.detailedAffairLoad = true
      this.axios
          .post("/queueItem/getQueueDetail/" +data.id )
          .then((res) => {
            this.detailedAffairLoad = false;
            if (res.code === 200) {
              this.detailedAffairForm = res.data.data[0]

              this.detailedAffairData = res.data.data
            }
          })
          .catch((err) => {
            this.detailedAffairLoad = false;
            console.log(err);
          });
    },
    // 事务查看详细信息 end

    // 事务打开模态框
    affairOpen(title, data) {
      this.affairTitle = title;
      this.affairVisible = true;
      this.queueItemTion.queueitemId  = data.id
      this.singleDta = data
      if (title == '编辑' || title == '克隆') {
        this.axios
            .post('/queueItem/getQueueItemContent/'+data.id)
            .then((res) => {
              this.btnLoad = false;
              if (res.code === 200) {
                this.affairForm.queueItemContentsJSON = res.data == '[]' ? '':res.data
              }
            })
            .catch((err) => {
              this.btnLoad = false;
              console.log(err);
            });
        this.$nextTick(()=>{
          this.affairForm = this.$lodash.pick(
              this.singleDta,
              this.$lodash.keys(this.affairForm)
          );
          // this.affairForm.queueItemContentsJSON = JSON.parse(this.affairForm.queueItemContentsJSON)
          // this.affairForm.status = 0
        })
      }else if(title== '详细信息'){

      }
      switch (title) {
        case '编辑':
          this.saveApi  =  '/queueItem/update'
          break;
        case '克隆':
          this.saveApi  =  '/queueItem/clone'
          break;
      }
      // this.queueItemTableChange()
    },
    // 查看事务项
    examineAffair(title,data) {
      this.affairSoHid = true;
      this.affairTion.queueId = data.id;
      this.cloneForm =  this.$lodash.cloneDeep(this.pagination)
      this.pagination.searchText = "";
      this.affairTion.current = 1;
      this.oneData = data
      this.searchJournalChange();

    },
    affairReturn() {
      this.affairSoHid = false;
      this.pagination = this.cloneForm
      this.pagination.current = 1;
      this.handleTableChange(this.pagination)
    },
    // 事务确认模态框
    affairHandleOk(){

      if (this.affairTitle == '编辑' || this.affairTitle == '克隆') {
        this.$refs.affairForm.validate((valid) => {
          if (valid) {
            this.btnLoad = true;
            let saveData = "";
            saveData = this.$lodash.cloneDeep(this.affairForm);
            if (saveData.status != 0) {
              saveData.status = this.singleDta.status
            }
            this.axios
                .post( this.saveApi, saveData)
                .then((res) => {
                  this.btnLoad = false;
                  if (res.code === 200) {
                    this.affairVisible = false;
                     notification.success({
                      message: res.message,
                      duration: 3,
                      customClass: "batch-import",
                    })
                    this.journalTableChange(this.pagCurrent);
                  }
                })
                .catch((err) => {
                  this.btnLoad = false;
                  console.log(err);
                });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
      switch (this.affairTitle) {

        case '删除':
          this.btnLoad = true;
          this.axios
              .post("/queueItem/delete/" +this.queueItemTion.queueitemId )
              .then((res) => {
                this.btnLoad = false;
                if (res.code === 200) {
                  this.$message.success("删除成功");
                  this.journalTableChange(this.pagCurrent);
                  this.affairVisible = false;
                }
              })
              .catch((err) => {
                this.btnLoad = false;
                console.log(err);
              });
          break;
      }
    },
    // 确认模态框
    handleOk() {
      if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = "";
            saveData = this.$lodash.cloneDeep(this.addForm);
            this.axios
                .post(this.saveApi, saveData)
                .then((res) => {
                  this.submitLoad = false;
                  if (res.code === 200) {
                        notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                    this.handleTableChange(this.modalTitle == "添加"? this.pagination:this.pagCurrent);
                    this.resetForm()
                  }
                })
                .catch((err) => {
                  this.submitLoad = false;
                  console.log(err);
                });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.submitLoad = true;
        this.axios
            .delete("/queue/delete/" + this.singleDta.id)
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                this.$message.success("删除成功");
                this.handleTableChange(this.pagCurrent);
                this.modalVisible = false;
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
      }
    },
    // 监听搜索输入框输入
    searchTextChange(val){
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        if (this.affairSoHid == false) {
          this.searchChange(val)
        }else{
          this.affairTion.searchText = val.srcElement._value
          this.searchJournalChange(val)
        }
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =   pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
          .post("queue/findPage", this.$qs.stringify(this.queryCondition))
          .then((res) => {
            this.tableLoad = false;
            if (res.code === 200) {
              this.tableLoad = false;
              this.tableData = res.data.records;
              this.queryCondition.total = res.data.total;

            }
          })
          .catch((err) => {
            console.log(err);
            this.tableLoad = false;
          });
    },
    // 搜索
    searchJournalChange(v) {
      this.affairCondition = this.$lodash.cloneDeep(this.affairTion)
      this.affairCondition.status =  this.pagination.status
      this.affairCondition.exceptionType =  this.pagination.exceptionType
      this.affairCondition.time =  this.pagination.time
      this.affairCondition.time = this.affairCondition.time ? this.affairCondition.time.join(',') : ''

      this.journalTableAjax()
    },
    // 监听翻页
    journalTableChange(pagination, filters, sorter) {
      this.affairCondition.pageNo = pagination.current
      this.affairCondition.current = pagination.current
      this.affairCondition.pageSize = pagination.pageSize
      this.journalTableAjax()
    },
    // 队列事务管理请求
    journalTableAjax() {
      this.affairLoad = true;
      this.axios
          .post(
              "/queueItem/findPage",
              this.$qs.stringify( this.affairCondition)
          )
          .then((res) => {
            this.affairLoad = false;
            this.columnsData = res.data.records;
            this.affairCondition.total = res.data.total;
            if (this.columnsData.length  == 0){
              this.queueExportDis = true
            }else{
              this.queueExportDis = false
            }
          })
          .catch((err) => {
            console.log(err);
            this.affairLoad = false;
          });
    },
    // QueueItemContent请求
    queueItemTableChange(pagination, filters, sorter) {
      this.queueItemLoad = true;
      this.queueItemTion = this.$lodash.merge({},this.queueItemTion,pagination);
      this.queueItemTion.pageNo = pagination ? pagination.current : 1;
      this.axios
          .post(
              "/queueItem/detailsQueueItemContent",
              this.$qs.stringify( this.queueItemTion)
          )
          .then((res) => {
            this.queueItemLoad = false;
            this.queueItemData = res.data.records;
            this.queueItemTion.total = res.data.total;
          })
          .catch((err) => {
            console.log(err);
            this.queueItemLoad = false;
          });
    },
    // 部门下拉框
    allorgList() {
      this.axios
          .post("/org/findOrg",'')
          .then((res) => {
            if (res.code === 200) {
              this.treeData = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },

    // 导出
    exportQuery(title){
      let exportParam = {},exportApi = '';
      exportParam = this.$lodash.cloneDeep(this.pagination)
      exportApi = '/queueItem/export'
      exportParam.time = exportParam.time ? exportParam.time.join(',') : ''
      exportParam.queueId = this.affairTion.queueId

      this.axios.post(exportApi, exportParam, { responseType: 'blob' }).then((res)=>{
        const blob = new Blob([res], {
          type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        });
        if (window.navigator.msSaveBlob) {          //IE兼容处理
          try {
            window.navigator.msSaveBlob(blob,fileName+'.xlsx');
          } catch (e) {
            console.log(e);
          }
        } else {
          const url = window.URL.createObjectURL(blob);
          const aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = url;
          aLink.setAttribute("download", this.oneData.name+'_'+this.$moment().format('YYYY-MM-DD HH:mm:ss'));
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      }).catch((err)=>{
        console.log(err.message);
      })




    },

    // 文件上传 start
    importQueue(){
      this.importModalVisible = true
    },
    // 清空文件
    resetFile(){
      this.importModalVisible = false
      this.fileList = [];
      this.searchJournalChange();
    },
    handleRemove() {
      this.fileList = [];
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      this.fileList = this.fileList.slice(-1);
      return false;
    },
    handleUpload() {
      if ( this.fileList.length > 0) {
        const { fileList } = this;

        const formData = new FormData();
        fileList.forEach(file => {
          formData.append('file', file);
          formData.append('queueId',  this.affairTion.queueId);
        });
        this.uploading = true;


        this.axios
            .post('/queueItem/importQueueItem', formData)
            .then((res) => {
              this.uploading = false
              if (res.code == 200) {
                this.fileList = [];
                    notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
            
                this.resetFile()
              }
            })
            .catch((err) => {
              this.uploading = false
              console.log(err);
            });
      } else {
        this.$message.warning('请选择您要批量导入的xls文件！');
      }


    },

    // 文件上传 end
  },
  beforeMount() {
  
    this.searchChange();
    this.allorgList()
  },
};
</script>

<style lang="scss" scoped>
.main-queue {

  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;
    header {
      display: flex;
      justify-content: space-between;
      padding: 16px;
      letter-spacing: 1px;
      background-color: #fff;
      border-bottom: 1px solid #f0f0f0;
      h3 {
        margin-bottom: -3px;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }
      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
      .job-page {
        height: 0;
        padding: 0px;
        margin-bottom: 20px;
        .ant-page-header-heading-title {
          line-height: 20px;
        }
        .ant-page-header-back {
          margin: 2px 0;
        }
      }
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }
    i.table-action {
      cursor: pointer;
      display: inline-block;
      margin: -5px 0;
      width: 30px;
      height: 30px;
      background: url("../assets/images/Table_action.png") no-repeat center;
      border-radius: 20px;
      vertical-align: top;
      &:active {
        background-color: #d8e6ff;
      }
    }
  }
}

::v-deep .ant-page-header-back {
  margin: 2px 0;
  margin-right: 16px;
  .ant-page-header-back-button{
    color: #6a768f;
  }
}
::v-deep .ant-page-header-heading{
  display: flex;
  align-items: center;
  .ant-page-header-heading-extra {
    span {
      display: block;
      float: left;
      margin-bottom: 0;
      padding-right: 12px;
      color: #6a768f !important;
      line-height: 23px !important;
      margin-left: -5px !important;
      cursor: pointer;
      font-size: 16px;
    }

    span:hover {
      color: #40a9ff !important;
    }
  }
}


.import_div{
  display: flex;
  flex-direction: column;
  div{
    display: flex;
    align-items: center;
    p{
      margin-left: 20px;
    }
    label{
      margin-bottom: 10px;
      span{
        color: red;
      }
    }
  }
}
::v-deep .ant-upload-list-item{
  height: 0px;
}
::v-deep .ant-upload-list{
  display: none;
}
::v-deep .ant-upload-list-item-info{
  display: none;
}

.fail_Info{
  margin-top:25px;
  P{
    color: #6a768f;
    font-weight: 600;
    display: flex;
    align-items: center;
    i{
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 8px;
      background-color: #6a768f;
    }
    span{
      font-weight: 500;
    }
  }
}

// 详细信息
.detailed_info_box{
     .remarks{
        margin-bottom: 10px;
       h4{
         font-weight: 600;
       }
       span{
         color: #717c93;
       }
       .ant-input{
         margin-bottom: 15px;
       }
       .ant-input[disabled]{
         background-color: #f9fafe;
       }
     }

     div{
       margin-bottom: 15px;
       i{
         display: inline-block;
         width: 5px;
         height: 5px;
         background-color: #717c93;
         border-radius: 50%;
         margin-bottom: 2px;
       }
       label{
         color: #717c93;
         font-weight: 600;
       }
       span{
         color: #717c93;

       }
     }
}
.table-box{
  max-height: 350px;
  overflow: scroll;
}
</style>
